import NewProduct from "../../../../components/@products/products/NewProduct";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ProductsPage() {

    return (
        <NewProduct 
            routeType={routeTypes.admin}
        />
    )
}       